import React from 'react';

export const oldCompaniesDate = new Date('2022-10-20T00:00:00');

